<ng-template #contentHeaderTemplate></ng-template>

<div class="row">
  <div class="col-12 pb-3">
    <div class="card">

      <div class="card-header fw-bold">
        {{ 'authenticated.statistics.form.card_header' | translate }}
      </div>

      <div class="card-body">
        <form [formGroup]="timeframesForm" class="row">

          <div class="col-12 col-md-6">
            <app-date-time
              label="{{ 'authenticated.statistics.form.start_date.label' | translate }}"
              [formControl]="timeframesForm.controls.timeframe_start_at"
            ></app-date-time>
          </div>

          <div class="col-12 col-md-6">
            <app-date-time
              label="{{ 'authenticated.statistics.form.end_date.label' | translate }}"
              [formControl]="timeframesForm.controls.timeframe_end_at"
            ></app-date-time>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>

@for (chartOption of chartOptions; track chartOption) {
  <div class="card mb-3">
    <div class="card-body">
      <div echarts [options]="chartOption"></div>
    </div>
  </div>
}
